var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('div',[_c('CSpinner',{attrs:{"grow":""}})],1):_c('div',[_c('CSelect',_vm._b({attrs:{"options":_vm.options},on:{"update:value":function($event){return _vm.$emit('update:value', $event)}}},'CSelect',_vm.attributes(),false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }